const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://linkedin.com/in/meron-gemechu-6992952a9"
        rel="noreferrer"
        className="home__social-icon"
        target="_blank"
      >
        <i style={{ color: "blue" }} className="uil uil-linkedin"></i>
      </a>
      <a
        href="https://gitlab.com/Meron12"
        rel="noreferrer"
        className="home__social-icon"
        target="_blank"
      >
        <i style={{ color: "orange" }} className="uil uil-gitlab"></i>
      </a>
      <a
        href="https://github.com/merongemechu"
        rel="noreferrer"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-github-alt"></i>
      </a>
    </div>
  );
};

export default Social;
